export const labelResources = {
    deletedSuccess: 'COMMON.DELETE_SUCCESS',
    updatedSuccess: 'COMMON.UPDATE_SUCCESS',
    createdSuccess: 'COMMON.CREATE_SUCCESS',
    importSuccess: 'COMMON.IMPORT_SUCCESS',
    sendSuccess: 'COMMON.SEND_SUCCESS',
};
